import React, { useEffect } from "react";

const GooglePhotosCarousel = () => {
  useEffect(() => {
    // Dynamically load the PublicAlbum script once on mount
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/publicalbum@latest/embed-ui.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      className="pa-carousel-widget"
      style={{ width: "640px", height: "480px", display: "none" }}
      data-link="https://photos.app.goo.gl/ir6n9vu7jDtrV9b89"
      data-title="test"
      data-description="6 new items added to shared album"
    >
      <object data="https://lh3.googleusercontent.com/pw/AP1GczNRPJ5rPagwb_SyPymhJwlnaOT4_-VsWH8snXvq3zzHKvIwtfXQ8Nex0dqoCqs_G7PYRVIjdsDRMBtsHogFE_zHhHk9H0S3AnVh5hixnw-grFQRHNo=w1920-h1080" />
      <object data="https://lh3.googleusercontent.com/pw/AP1GczNCH8xYZn3JWgNy64FasoWCHjbq3l_LKW-l3KZnjc0LK-1zxzQ5QKQqq-usiGuuMgJVg71f-Ctq4jaTcjl5j0qNtCtJ_QX5XSlqDeLNummg-N2YDUQ=w1920-h1080" />
      <object data="https://lh3.googleusercontent.com/pw/AP1GczMiJuZe8s7Ml2y7DjUwwao_N5ZWtpk0LB37Qr5CksasjC66sSUhUDHon2dvtVPk9GD6xsZxxIEtAf97UjjxMDqnjWc7Za6_8FH_9d4ObUa6rmv064I=w1920-h1080" />
      <object data="https://lh3.googleusercontent.com/pw/AP1GczPanECi4BEQ_McY9y7D_oqq772K8u1WLwHbPkmdtobTxZM41i-zrSfMppfOuJkxiZcYXi3O8NJzm2l6GGgmk7lA3ZPMoZYish1uRv_KcNrfSlBnYLk=w1920-h1080" />
      <object data="https://lh3.googleusercontent.com/pw/AP1GczMrsWxx9dOGRaG6d9uIKfBjL9OWHZNS8Tv1nr7tXFOrz_qVbNV9QKU86o2UwFYjQ1hxNEKkjTpP7QoJXo4_JQMPy1khBEetCgUpSYBVMQETud5M5K8=w1920-h1080" />
      <object data="https://lh3.googleusercontent.com/pw/AP1GczO2Y2FikataR-41L9F9aYnVPaLSr6e_qQv_gHGFEfAJo13HGjiPF0BAJm8cBPxMxGMIW5xK4VcGhXEARaJEmjbQ1U6QRE2Wn7dGJABvvXqrGwmhwm4=w1920-h1080" />
    </div>
  );
};

export default GooglePhotosCarousel;
